module.exports = __webpack_public_path__ + "static/media/ts13tj1023.9c5481b7.png";